"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Share = createSVGIconV2(
  <>
    <path
      d="M17 9H19C19.5523 9 20 9.44772 20 10V21.5C20 22.0523 19.5523 22.5 19 22.5H5C4.44772 22.5 4 22.0561 4 21.5038C4 19.3156 4 13.9684 4 9.99984C4 9.44755 4.44772 9 5 9H7"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M12 14V2M12 2L8 6M12 2L16 6"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </>,
  { displayName: "Share", scalingFactor: 134 / 132 },
  {
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
